import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

export const PanelFinancingModalInsuranceLink = ({insuranceId}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {INSURANCE_IDS} = config.get('financing')
  const {URL_INSURANCE_INFO_LIFE_PLUS, URL_INSURANCE_INFO_GAP} = config.get('financing')

  const {SANTANDER_WITH_LIFE_INSURANCE} = INSURANCE_IDS

  return (
    <div className="mt-PanelFinancing-modalInsuranceLink">
      {insuranceId === SANTANDER_WITH_LIFE_INSURANCE ? (
        <>
          <span>{i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.LINK_TEXT_LIFE_PLUS')}</span>
          <a className="mt-PanelFinancing-modalInsuranceLinkText" href={URL_INSURANCE_INFO_LIFE_PLUS} target="_blank">
            {i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.LINK_LIFE_PLUS')}
          </a>
        </>
      ) : (
        <>
          <span>{i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.LINK_TEXT_1_GAP')}</span>
          <a className="mt-PanelFinancing-modalInsuranceLinkText" href={URL_INSURANCE_INFO_LIFE_PLUS} target="_blank">
            {i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.LINK_1_GAP')}
          </a>
          <span>{i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.LINK_TEXT_2_GAP')}</span>
          <a className="mt-PanelFinancing-modalInsuranceLinkText" href={URL_INSURANCE_INFO_GAP} target="_blank">
            {i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.LINK_2_GAP')}
          </a>
        </>
      )}
    </div>
  )
}

PanelFinancingModalInsuranceLink.propTypes = {
  insuranceId: PropTypes.string
}
